import { _deepClone } from '../../../helpers/utilities';
import { writable } from 'svelte/store';
import type { ITempSchemeObj, ISensor } from '../../../types/TemperatureSchemeType';

interface ITmpThermostat {
	_enabled: boolean;
	_meta: {
		room: string;
		position: number;
		name: string;
	};
	units: 'C' | 'F';
	default_output: string;
	threshold: number;
	base: number;
	intervals: [];
	sensor: string;
	controls: {
		type: string;
		devices: string[];
	};
	type: 'cool' | 'heat' | undefined;
	id: undefined | string | number;
}

// const create_temp_scheme = () => {
// 	let temp_scheme: ITempSchemeObj = {
// 		_enabled: false,
// 		_run_on_ingest: true,
// 		_meta: {
// 			name: '',
// 			position: -1,
// 			room: '',
// 			default_output: 'normal',
// 			hw_id: '',
// 			ext_ind: '',
// 			data: undefined,
// 			type: ''
// 		},
// 		isinfh: false,
// 		intervals: [],
// 		funcs: [
// 			{
// 				_name: 'fixup',
// 				tschem_tempfix: '_parent',
// 				fix: 1
// 			},
// 			{
// 				_name: 'fixdown',
// 				tschem_tempfix: '_parent',
// 				fix: -1
// 			},
// 			{
// 				_name: 'fixset',
// 				tschem_tempfix: '_parent',
// 				fix: {
// 					r: 'p:temp'
// 				},
// 				isrel: {
// 					r: 'p:isrel',
// 					def: true
// 				}
// 			},
// 			{
// 				_name: 'report',
// 				tschem_report: '_parent'
// 			}
// 		],
// 		report: {
// 			notifyUI: {
// 				type: 'tmp_sch',
// 				target_temp: '%item%'
// 			},
// 			tschem_params: true
// 		},
// 		tschem: { r: '' },
// 		rrtrig: {
// 			rr: 'dt:t'
// 		},
// 		ths: 0.5,
// 		deftemp: 18,
// 		tocool: {
// 			blk: []
// 		},
// 		toheat: {
// 			blk: []
// 		}
// 	};
// 	const { subscribe, set, update } = writable(temp_scheme);

// 	return {
// 		subscribe,
// 		change: (newScheme: ITempSchemeObj) => {
// 			update((props: ITempSchemeObj) => {
// 				props = _deepClone(newScheme) as ITempSchemeObj;
// 				return props;
// 			});
// 		},
// 		reset: () => set(temp_scheme)
// 	};
// };

// export const temp_scheme_prototype = create_temp_scheme();

export const temp_scheme_prototype: ITempSchemeObj = {
	_enabled: false,
	_run_on_ingest: true,
	failsafe: 'tocool',
	_meta: {
		name: '',
		position: -1,
		room: '',
		default_output: 'normal',
		hw_id: '',
		ext_ind: '',
		data: undefined,
		type: '',
		advancedSettingsIsOpen: false,
		F: {
			heat: {
				min: '41',
				max: '95',
			},
			cool: {
				min: '41',
				max: '95',
			},
		},
		C: {
			heat: {
				min: '5',
				max: '35',
			},
			cool: {
				min: '5',
				max: '35',
			},
		},
	},
	isinfh: false,
	intervals: [],
	funcs: [
		{
			_name: 'fixup',
			tschem_tempfix: '_parent',
			fix: 1,
		},
		{
			_name: 'fixdown',
			tschem_tempfix: '_parent',
			fix: -1,
		},
		{
			_name: 'fixset',
			tschem_tempfix: '_parent',
			fix: {
				r: 'p:temp',
			},
			isrel: {
				r: 'p:isrel',
				def: true,
			},
		},
		{
			_name: 'report',
			tschem_report: '_parent',
		},
	],
	report: {
		notifyUI: {
			type: 'tmp_sch',
			target_temp: '%item%',
			isDisabled: '%disabled%',
		},
		tschem_params: true,
	},
	tschem: { r: '' },
	rrtrig: {
		rr: 'dt:t',
	},
	ths: 0.5,
	deftemp: 18,
	tocool: {
		blk: [],
	},
	toheat: {
		blk: [],
	},
};
